export default {
      id: "icon-menu-toggle-usage",
      viewBox: "0 0 20 15.5",
      url: __webpack_public_path__ + "Assets/Sprite.svg#icon-menu-toggle",
      toString: function () {
        return this.url;
      }
    }